export default __webpack_public_path__ + "static/photo-25-5012d67851431b87a83ca187c1d82bc0.jpg";